export default __webpack_public_path__ + "static/media/radio.8a651dcc.svg";